import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/styles/index.scss';
import '@/permission' // permission control
import allUrl from './utils/configure.js'//公共链接
// import 'lib-flexible/flexible'
import "./filters/index.js";//自定义过滤器
Vue.prototype.$baseUrl = allUrl
Vue.config.productionTip = false
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')